module.exports = __webpack_public_path__ + "img/2_b.5093f7c1.jpg";